// @ts-strict-ignore
import md5 from 'md5';

import {AvatarImageSize, GRAVATAR_URL} from 'common/constants';

// must match with number of folders in ./icons
const ICONS_TOTAL = 12;

// we do .substring(0, 8) to not be imprecise when we parse to int
const hash = (distinctId) => parseInt(md5(distinctId || ``).substring(0, 8), 16);

export function getDefaultIconUrl(distinctId: string, size: AvatarImageSize = AvatarImageSize.Medium) {
  const index = String(hash(distinctId) % ICONS_TOTAL).padStart(2, `0`);
  return `https://cdn.mxpnl.com/static/tracked-user-icons/${index}/${size}.png`;
}
// We use gravatar as proxy for tracked users with 'img-src'
export function getGravatarUrl(email, size = null, defaultImageUrl = GRAVATAR_URL, forceDefault = false): string {
  let ret = defaultImageUrl;
  ret = `https://secure.gravatar.com/avatar/${md5(email || ``)}`;
  ret += `?d=${encodeURIComponent(defaultImageUrl)}`;
  if (forceDefault) {
    ret += `&f=y`;
  }

  if (size) {
    ret += `&s=${size}`;
  }

  return ret;
}
